import { createSlice } from '@reduxjs/toolkit';


const initialState = {
    filter: false,
    search: ""

}

const filterSlice = createSlice({
    name: "filter",
    initialState,
    reducers: {
        setFilter: (state, action)=>{
            state.filter = action.payload
        },
        setSearch: (state, action)=>{
            state.search = action.payload
        },
    }
})

export default filterSlice.reducer;
export const { setFilter, setSearch  } = filterSlice.actions;